<template>
  <div>
    <div v-if="organization">
      <b-container class="mt-lg-3">
        <div class="mt-lg-5">
          <!-- header -->
          <div class="row bg-white mb-4 pt-4 border-custom-lgr">
            <div class="col-lg-5 col-sm-5 col-md-6 col-xs-12">
              <div class="text-left p-3">
          <span v-if="organization.bannerUrl">
            <b-img-lazy
              :src="organization.bannerUrl"
              class="mb-2"
              fluid-grow>
            </b-img-lazy>
            <br>
          </span>
                <span v-else>
            <b-img
              :src="imageUrl"
              class="mb-2"
              fluid-grow>
            </b-img>
            <br>
          </span>
                <span class="text-muted" title="Creation date of the organisation" v-b-tooltip.hover.bottom>
            <font-awesome-icon icon="calendar-alt"/> {{ organization.created | utcLocalDatetime }}
          </span>
              </div>
            </div>
            <div class="col-lg-7 col-sm-7 col-md-6 col-xs-12">
              <div class="p-3 text-left">
                <h3 class="mb-5">
                  {{ organization.name }} <span v-show="isEditable"> | </span>
                  <router-link :to="{ name: 'organizationEdit', params: { id: organization.id }}"
                               class="text-dark"
                               title="Edit the organisation"
                               v-b-tooltip.hover.top
                               v-show="isEditable">
                    <b-button class="btn btn-sm btn-dark">
                      <font-awesome-icon icon="edit" size="sm"/>
                      Edit
                    </b-button>
                  </router-link>
                  <b-link @click.prevent="showMsgDelete(organization.id, organization.name)"
                          class="text-danger"
                          title="Delete the organisation"
                          v-b-tooltip.hover.top
                          v-show="isDeletable">
                    <b-button class="btn btn-sm btn-danger">
                      <font-awesome-icon icon="trash-alt" size="sm"/>
                      Delete
                    </b-button>
                  </b-link>
                </h3>
                <p>
                  <span v-if="organization.type.includes('Other')" class="mr-5"
                        title="Type of the organisation"
                        v-b-tooltip.hover.bottom>
                    <font-awesome-icon icon="landmark"/> {{ organization.type[organization.type.length - 1] }}
                  </span>
                  <span v-else-if="typeof(organization.type) === 'string'" class="mr-5" title="Type of the organisation"
                        v-b-tooltip.hover.bottom>
                                <font-awesome-icon icon="landmark"/> {{ organization.type }}
                              </span>
                  <span v-else class="mr-5" title="Type of the organisation" v-b-tooltip.hover.bottom>
                                <font-awesome-icon icon="landmark"/> {{ organization.type[0] }}
                              </span>
                  <span title="Visibility of the organisation" v-b-tooltip.hover.bottom>
                                <span class="font-weight-bold">Visibility:</span> {{ visibility }}
                              </span>
                </p>
                <p title="Notes about the organisation" v-b-tooltip.hover.leftbottom v-show="organization.notes">
                  <font-awesome-icon icon="clipboard"/>
                  {{ organization.notes }}
                </p>

                <p v-show="organization.url">
                  Visit
                  <b-link :href="getWebsiteLink" target="_blank"> website</b-link>
                </p>

                <p class="text-justify pt-5 mb-4"
                   v-show="organization.keywords">
                  <Keywords type="organisation" title="Keywords" v-b-tooltip.hover.left
                            v-bind:keywords="organization.keywords"/>
                </p>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12 p-3 mb-1 bg-white border-custom-lgr">
              <!--          <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12 p-3 mb-1 bg-white border-custom-lgr">-->
              <div class="text-left p-3">
                <h4>About</h4>
                <hr>
                {{ organization.description }}
              </div>
              <!--          </div>-->
              <div class="col-lg-1 col-sm-1 col-md-1"></div>
              <div class="col-lg-1 col-sm-1 col-md-1"></div>

              <!--          <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12 p-3 mb-1 bg-white border-custom-lgr">-->
              <div class="text-left p-3">
                <h4>Services</h4>
                <hr>
                <span v-if="organization.services">
                <p>{{ organization.services }}</p>
                  <!--                <p class="text-left">-->
                  <!--                  <font-awesome-icon class="mr-2" icon="caret-right" size="lg"/>-->
                  <!--                  {{ service }}-->
                  <!--                </p>-->
              </span>
                <span
                  v-if="!organization.services || organization.services === ''">No services have been included.</span>
              </div>
              <!--          </div>-->
            </div>

            <div class="col-lg-4 col-sm-4 col-md-4 col-xs-12 p-3 mb-1 bg-white border-custom-lgr">
              <div class="text-left p-3">
                <div v-if="organization.address || organization.city || organization.country">
                  <h4>Find us</h4>
                  <hr>
                  <span v-if="organization.address">
                  <font-awesome-icon class="mr-2" icon="map-marker-alt" size="md"/>
                  {{ organization.address }}<br>
                </span>
                  <span v-if="organization.city">
                  <font-awesome-icon class="mr-2" icon="city" size="sm"/>
                  {{ organization.city }}<br>
                </span>
                  <span v-if="organization.country">
                  <font-awesome-icon class="mr-2" icon="globe-europe" size="md"/>
                  {{ organization.country }}<br>
                </span>
                  <br>
                  <br>
                </div>
                <h4>Contact</h4>
                <hr>
                <span v-if="organization.contact" v-bind:key="contact" v-for="contact in organization.contact">
                  <p v-if="contact.startsWith('https') || contact.startsWith('http')">
                    <font-awesome-icon class="mr-2" icon="at" size="lg"/>
                    <a :href="contact" target="_blank" class="text-left">
                      {{ contact }}
                    </a>
                  </p>
                  <p v-else-if="contact.startsWith('www')">
                    <font-awesome-icon class="mr-2" icon="at" size="lg"/>
                    <a :href="'https://' + contact" target="_blank" class="text-left">
                      {{ contact }}
                    </a>
                  </p>
                  <p v-else class="text-left">
                      <font-awesome-icon class="mr-2" icon="at" size="lg"/>
                      {{ contact }}
                  </p>
                </span>
                <p v-if="organization.telephone">
                  <font-awesome-icon class="mr-2" icon="phone-square-alt" size="lg"/>
                  {{ organization.telephone }}
                </p>
                <p
                  v-if="(!organization.contact || organization.contact.length === 0) && (!organization.telephone || organization.telephone.length === 0)">
                  No contact information have been provided.</p>
              </div>
            </div>
            <!--        </div>-->

            <!--        <div class="row mb-3">-->
            <!--          <div class="col-lg-4 col-sm-4 col-md-4 col-xs-12 p-3 mb-1 bg-white border-custom-lgr">-->
            <!--            <div class="text-justify p-3">-->
            <!--              <h4>Interests</h4>-->
            <!--              <hr>-->
            <!--              <span v-for="interest in organization.interest" v-bind:key="interest">-->
            <!--            <p class="text-left">-->
            <!--              <font-awesome-icon icon="hand-point-right" size="lg" class="mr-2"></font-awesome-icon>-->
            <!--              {{ interest }}-->
            <!--            </p>-->
            <!--          </span>-->
            <!--            </div>-->
            <!--          </div>-->

            <!--          <div class="col-lg-4 col-sm-4 col-md-4 col-xs-12 p-3 mb-1 bg-white border-custom-lgr">-->

            <!--          <div class="col-lg-4 col-sm-4 col-md-4 col-xs-12 p-3 mb-1 bg-white border-custom-lgr">-->
            <!--&lt;!&ndash;          <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12 p-3 mb-1 bg-white border-custom-lgr">&ndash;&gt;-->
            <!--            <div class="text-justify p-3">-->
            <!--              <h4>Contact</h4>-->
            <!--              <hr>-->
            <!--              <span v-bind:key="contact" v-for="contact in organization.contact">-->
            <!--            <p class="text-left">-->
            <!--              <font-awesome-icon class="mr-2" icon="address-book" size="lg"></font-awesome-icon>-->
            <!--              {{ contact }}-->
            <!--            </p>-->
            <!--            <p> {{ organization.telephone }} </p>-->
            <!--          </span>-->
            <!--            </div>-->
            <!--          </div>-->
          </div>

        </div>
      </b-container>
    </div>
    <div v-else>
      <NoAccess></NoAccess>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {eventBus} from '../main'
import backgroundImage from '../assets/organization-bg.jpg'
import Keywords from '../components/Keywords'
import NoAccess from '../components/NoAccess'

export default {
  name: 'OrganizationView',
  components: {
    Keywords,
    NoAccess
  },
  data() {
    return {
      isEditable: false,
      isDeletable: false,
      imageUrl: backgroundImage,
      organization: {},
      loaded: false
    }
  },
  watch: {
    '$route'(to, from) {
      if (from.params.id && to.params.id) {
        this.$router.go(to)
      }
    }
  },
  created() {
    this.getOrganization()
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ]),
    visibility() {
      return (this.organization.publicReadable === true) ? 'Public' : 'Private'
    },
    getWebsiteLink() {
      let link = this.organization.url
      if (link !== undefined && link.startsWith('https')) {
        return link
      }
      if (link !== undefined && link.startsWith('www')) {
        return '//' + link
      }
      if (link !== undefined && link.startsWith('http')) {
        return link
      }
      return ''
    }
  },
  beforeRouteLeave(to, from, next) {
    eventBus.$emit('organisationSearchNull', null)
    next()
  },
  methods: {
    getOrganization: function () {
      let orgId = this.$route.params.id
      this.$store.dispatch('getOrganizationEntity', orgId).then(
        response => {
          eventBus.$emit('organisationSearchedName', response.name)
          this.organization = response
          this.loaded = true
          this.$store.dispatch('getUser').then(
            data => {
              if (data.id === response.creator.id) {
                this.isEditable = true
                this.isDeletable = true
              }
            }
          )
        }
      )
    },
    showMsgDelete(orgId, orgTitle) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this organisation.', {
        title: 'Are you sure you want to delete ' + orgTitle + '?',
        size: 'bg',
        buttonSize: 'bg',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            this.deleteOrganization(orgId)
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    deleteOrganization(orgId) {
      this.$store.dispatch('deleteOrganizationEntity', orgId).then(
        data => {
          this.$router.push({name: 'organizations'})
        })
    }
  }
}
</script>

<style scoped>
.border-custom-lgr {
  border: 1px solid #d3d3d366;
}
</style>



// WEBPACK FOOTER //
// src/views/OrganizationView.vue